const API_TARGETS = {
    production: 'https://api.bypass-vpn.ru',
    test: 'https://api-bypass.valoudya.ru',
};

const target = process.env.REACT_APP_API_TARGET;

export const API_URL =
    process.env.REACT_APP_API_URL
    || API_TARGETS[target]
    || API_TARGETS.production;

export const USE_MOCKS = process.env.REACT_APP_USE_MOCKS === 'true';
export const API_TARGET = target || (API_URL === API_TARGETS.test ? 'test' : 'production');

export const TOKEN_KEY = 'bypass_auth_token';
export const USER_KEY = 'bypass_auth_user';
export const REFRESH_TOKEN_KEY = 'bypass_auth_refresh_token';

export const UNAUTHORIZED_EVENT = 'bypass:unauthorized';
